import { Component, Input } from '@angular/core';
import { GymUtils } from '../../../util/gym-util';

@Component({
  selector: 'gymfinder-changelog-options-strings',
  templateUrl: './changelog-options-strings.component.html',
  styleUrls: ['./changelog-options-strings.scss'],
  standalone: false,
})
export class ChangelogOptionsStringsComponent {
  @Input()
  options: any[];

  @Input()
  fieldType:
    | 'equipmentsToBring'
    | 'gymEquipments'
    | 'gymInfos'
    | 'gymTypes'
    | 'geniusFeatures';

  getTranslation = () => GymUtils.getOptionsTranslation(this.fieldType);
}
